<template>
  <section id="toTop">
    <span @click="scrollToTop(0, 500)">PAGE TOP</span>
  </section>
</template>

<script>
// require('@/utils/scrollTo.js')
require("@/utils/jquery.min.js");
export default {
  name: "ToTop",
  data() {
    return {};
  },
  components: {},
  computed: {},
  methods: {
    scrollToTop(to, duration) {
      // scrollTo(0, 500);
      $("#app").animate({ scrollTop: 0 }, 500);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
#toTop {
  text-align: center;
  > span {
    display: inline-block;
    padding-right: 37px;
    font-weight: 200;
    font-size: 16px;
    line-height: 22px;
    color: #333;
    background: url(../assets/toTop.png) right/22px no-repeat;
    cursor: pointer;
  }
}
</style>
